import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/[locale]/blog/vide-maison-uccle-guide/PageClient.jsx");
